import { LocalDate, localDateFromDate } from "@flockcover/flock-svc-core-types"
import { DatePicker, Dialog, DropdownButtonItem, Flex } from "@shared/primitive-components"
import { DateFilter, parseDateRange } from "@shared/utils/formatters/dates"
import { useState } from "react"

export type DateRange = { fromDate: DateFilter | string; toDate: string | null }

type Props = {
  dateRange: DateRange
  setDateRange: (dateRange: DateRange) => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export const TripCustomDate = ({ setDateRange, dateRange, isOpen, setIsOpen }: Props) => {
  const { fromDate: defaultFromDate, toDate: defaultToDate } = parseDateRange(
    dateRange.fromDate,
    dateRange.toDate,
    DateFilter.LAST_7_DAYS
  )

  const [localFromDate, setLocalFromDate] = useState<LocalDate>(localDateFromDate(defaultFromDate, `Europe/London`))
  const [localToDate, setLocalToDate] = useState<LocalDate>(localDateFromDate(defaultToDate, `Europe/London`))

  const onCustomDateSelected = () => {
    setDateRange({ fromDate: localFromDate, toDate: localToDate })
    setIsOpen(false)
  }

  const onCustomDateCancelled = () => {
    setIsOpen(false)
  }

  return (
    <Dialog
      open={isOpen}
      title="See all trips between:"
      primaryButton={{ action: onCustomDateSelected, text: `Confirm` }}
      closeDialog={onCustomDateCancelled}
    >
      <Flex flexDirection="column">
        <DatePicker value={localFromDate} onChange={(n) => n !== undefined && setLocalFromDate(n)} />
        <p>&nbsp;AND&nbsp;</p>
        <DatePicker value={localToDate} onChange={(n) => n !== undefined && setLocalToDate(n)} />
      </Flex>
    </Dialog>
  )
}

export const tripCustomDateFilterItems: Array<DropdownButtonItem<DateFilter>> = [
  {
    text: `Last 30 days`,
    value: DateFilter.LAST_30_DAYS,
  },
  {
    text: `Last 7 days`,
    value: DateFilter.LAST_7_DAYS,
  },
  {
    text: `Yesterday`,
    value: DateFilter.YESTERDAY,
  },
  {
    text: `Today`,
    value: DateFilter.TODAY,
  },
]

export const tripCustomDateFilterCustomItem: DropdownButtonItem<DateFilter> = {
  text: `Custom`,
  value: DateFilter.CUSTOM,
}
